export default "__VITE_ASSET__39304ad1__"